import styled from "styled-components";
export const StatusItem = styled.div`
    display: flex;
    align-items: center;

    .label {
        margin-right: 8px;
        color: rgba(0, 0, 0, 0.85);
    }

    .icon {
        font-size: 16px;
        &.success {
            color: #52c41a;
        }
        &.error {
            color: #ff4d4f;
        }
    }
`;
